import { isDesktopApp } from '@/desktop/electronApi';

/** True when React Router must use hash paths (Electron loadFile / file://). */
export function usesHashRouter(): boolean {
  if (typeof window === 'undefined') return false;
  return (
    isDesktopApp() ||
    window.location.protocol === 'file:' ||
    import.meta.env.VITE_DESKTOP === '1'
  );
}

/**
 * Hard navigation that works for both BrowserRouter (web) and HashRouter (desktop).
 * Prefer react-router `navigate()` for in-app routes when a Router is mounted.
 */
export function hardNavigate(path: string): void {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  if (usesHashRouter()) {
    const base = window.location.href.split('#')[0];
    window.location.href = `${base}#${normalized}`;
    return;
  }
  window.location.href = normalized;
}
